export enum Account__CancelIntent__Reason {
  AppointmentPrice = 'APPOINTMENT_PRICE',
  Bankruptcy = 'BANKRUPTCY',
  NegativeCx = 'NEGATIVE_CX',
  NothingToStore = 'NOTHING_TO_STORE',
  PayToVacate = 'PAY_TO_VACATE',
  PrefersSelfStorage = 'PREFERS_SELF_STORAGE',
  StoragePrice = 'STORAGE_PRICE',
}
